import { render, staticRenderFns } from "./LandingSectionCollapse.vue?vue&type=template&id=5ce1caac&scoped=true&"
import script from "./LandingSectionCollapse.vue?vue&type=script&lang=js&"
export * from "./LandingSectionCollapse.vue?vue&type=script&lang=js&"
import style0 from "./LandingSectionCollapse.vue?vue&type=style&index=0&id=5ce1caac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce1caac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingText: require('/home/circleci/repo/components/landing/elements/LandingText.vue').default,LandingButton: require('/home/circleci/repo/components/landing/elements/LandingButton.vue').default,LandingImage: require('/home/circleci/repo/components/landing/elements/LandingImage.vue').default})
